import {QuestionTypeText} from "../../types/gameSession";
import React from "react";
import {useAppDispatch} from "../../app/store";
import {updateText} from "../../app/slices/gameSession";

type Props = {
    question: QuestionTypeText;
}

const QuestionText = ({question}: Props) => {
    const dispatch = useAppDispatch();

    const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        const { value, id} = e.target;
        const existingOption = question.options.find(option => option.key === id);

        if (existingOption) {
            dispatch(updateText({
                ...existingOption,
                value: value
            }));
        }

    }

    const fields = (
        <div className='open-text-container'>
            {question.options.map((option) => (
                <div key={option.key} className='form-group'>
                    <label className="form-label" htmlFor={option.key}>{option.label}</label>
                    {option.field_type === 'textarea' ? (
                        <textarea
                            className="form-control"
                            id={option.key}
                            value={option.value}
                            name={option.key}
                            required={option.required}
                            onChange={handleInputChange}
                            rows={4}
                        />
                    ) : (
                        <input
                            className="form-control"
                            type="text"
                            id={option.key}
                            value={option.value}
                            name={option.key}
                            required={option.required}
                            onChange={handleInputChange}
                        />
                    )}
                </div>
            ))}
        </div>
    );

    if (!question.image) return fields;

    return (
        <div className='text-question-with-image'>
            <img className='text-question-image' src={question.image} alt={question.title}/>
            {fields}
        </div>
    );

}

export default QuestionText;